import { API_URL } from "@config";
import { createErrorPlugin, createFetchTransport, createHttpClient } from "@kalodata/http";
import { createSlicePlugin } from "./slicePlugin";
import type { ClipHttpContext, ClipHttpMeta } from "./types";
import {
  createAttachAccessTokenPlugin,
  createLegacyHeadersPlugin,
  createLegacyQueryPlugin,
  DEFAULT_CLIP_TIMEOUT_MS,
  isBusinessError,
} from "./httpPlugins";
import { createSentryPlugin } from "./sentryPlugin";

export const clipLogHttpClient = createHttpClient<ClipHttpMeta, ClipHttpContext>({
  baseUrl: API_URL,
  defaultTimeoutMs: DEFAULT_CLIP_TIMEOUT_MS,
  transport: createFetchTransport<ClipHttpMeta, ClipHttpContext>(),
  plugins: [
    createLegacyHeadersPlugin(),
    createLegacyQueryPlugin(),
    createAttachAccessTokenPlugin(),
    createErrorPlugin<ClipHttpMeta, ClipHttpContext>({
      isBusinessError,
    }),
    createSentryPlugin(),
    createSlicePlugin<ClipHttpMeta, ClipHttpContext>(),
  ],
});
